module.exports = "<app-task-overview-view\r\n[tasks]=\"tasks\"\r\n[companies]=\"companies\"\r\n(refreshDataEmitter)=\"GetTasks($event)\"\r\n(createNotificationEmitter)=\"CreateNotification($event)\"\r\n(updateTaskEmitter)=\"updateTask($event)\"\r\n(updateActivitiesEmitter)=\"updateTaskActivities($event)\"\r\n></app-task-overview-view>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/task-overview/task-overview.component.html
// module id = ../../../../../src/app/controllers/notification-overview/task-overview/task-overview.component.html
// module chunks = main